import { Injectable } from '@angular/core'
import { BaseService } from '../base-service/base.service'
import { MENU } from '../constants/microservice.name.constants'
import { map } from 'rxjs/operators'
import { IPagedResponse } from '../pagedResponse.interface'
import { MenuItem } from '../../app/coreUi-files/containers/default-layout/dto/MenuDto'

@Injectable({
	providedIn: 'root'
})
export class MenuService extends BaseService {
	override microserviceName = MENU

	createMenuItem(value: any) {
		return super.postService(value, 'menu/create')
	}

	getMenuItemListByPage(query: any) {
		return super.getService('menu/get-page', query).pipe(map(res => res.body as IPagedResponse<Menu>))
	}

	getList() {
		return super.getService('menu/get-list', {
			term: '',
			limit: 100
		}).pipe(map((res: any) => res.body))
	}

	deleteOneItemOfMenu(id: any) {
		return super.deleteDeleteService('menu/delete', {id: id})
	}

	editOneItemOfMenu(entity: any, id: any) {
		return super.putService(entity, 'menu/update', {id: id})
	}

	getMyMenu() {
		return super.getService('menu/get-my-menu').pipe(
			map((res: any) => res.body as MenuItem[])
		)
	}

	getMenuByPostId(postId: any) {
		return super.getService('menu/get-list-menu-by-post-id', {postId}).pipe(
			map((res: any) => res.body)
		)
	}

	addMenuLabel(menuLabel: menuLabel) {
		return super.postService(menuLabel, 'menu-label/add')
	}

	removeMenuLabel(menuLabel: menuLabel) {
		return super.deleteDeleteService('menu-label/remove', '', menuLabel)
	}

	getLabelIdListByMenuId(menuId: string) {
		return super.getService('menu-label/get-label-id-list/by-menu-id', {menuId}).pipe(map((res: any) => res.body))
	}

	getMenuIdListByLabelId(labelId: number) {
		return super.getService('menu-label/get-menu-id-list/by-label-id', {labelId}).pipe(map((res) => res.body as number[]))
	}

	changeMenuActivationStatus(status: string, id: any) {
		return super.putService(null, 'menu/update-status', {id: id, status: status})
	}
}

export interface menuLabel {
	labelId: number,
	menuId: string
}

export interface Menu {
	id: string
	hasChild: boolean
	name: string
	parentId: string | null
	status: 'ACTIVE' | 'DE_ACTIVE'
	url: string
}
